/**
 * Module definition for all common implementations.
 *
 * @module stack.common
 */
angular.module('stack.common', [
  'stack.common.api',
  'stack.common.i18n',
  'stack.common.storage',
  'stack.common.ui',
  'stack.common.utility'
]);
